<template>
    <div>
        <!--<div class="page-title">
            <h1 class="float-left">Select Vendor</h1>
            <div class="title-right float-right">
                <router-link :to="{ name: 'addVendor'}" class="btn custom-btn">New Vendor</router-link>
                <a href="javascript:void(0)" data-toggle="modal" data-target="#vendorAddModal" class="btn custom-btn">New Vendor</a>-->
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col-lg-auto"><h4 class="card-title mb-0">Select Vendor</h4></div>
                    <div class="col-auto ms-sm-auto">
                        <!--<router-link :to="{ name: 'addVendor'}" class="btn custom-btn">New Vendor</router-link>-->
                        <a href="javascript:void(0)" data-toggle="modal" data-target="#vendorAddModal" class="btn custom-btn">New Vendor</a>
                    </div>
                </div>

            </div><!-- end card header -->

            <div class="card-body form-steps">
                <div class="select-step product-select-step">
                    <!-- progressbar -->
                    <div class="step-arrow-nav mb-4">
                        <ul id="progressbar" class="nav nav-pills custom-nav nav-justified">
                            <li class="active">Step 1</li>
                            <li class="active">Step 2</li>
                            <li>Step 3</li>
                        </ul>
                    </div>
                    <!-- fieldsets -->
                    <fieldset class="search">
                        <div class="row">
                            <div class="col-sm-6 col-md-6">
                                <form class="form-inline" action="" @submit.prevent="search()">
                                    <div class="search-box">
                                            <button class="btn btn-outline-secondary custom-btn" type="button" @click.prevent="search">
                                        <i class="ri-search-line search-icon"></i></button>
                                            <input v-model="search_filter" type="text" class="form-control search" placeholder="Quick Search">

                                        </div>
                                </form>
                            </div>
                        </div>
                    </fieldset>
                    <div class="product-create product-height" v-if="isMounted">
                        <Vendors :selectedVendor="newOrder.vendor_id" :search_filter="search_filter"
                                @selectVendor="selectVendor($event)" :bus="bus" ref="vendorList"></Vendors>
                    </div>

                    <div class="btnrow text-right">
                        <button  type="button" @click="goBack" class="btn btn-light btn-label left-btn previestab w-lg"><i  class="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back</button>
                        <router-link :to="{ name: 'purchaseProvideOtherInfo'}" class="btn  btn-success right btn-label ml-3"
                                    :class="[newOrder.vendor_id == null ? 'disabled':'']">Next <i  class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                        </router-link>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="poModal">
                <div class="modal-dialog" style="max-width: 90% !important;">
                    <div class="modal-content">

                        <!-- Modal Header -->
                        <div class="modal-header p-3 bg-soft-info">
                            <h5 class="modal-title">Purchase Orders</h5>
                            <button type="button" class="close" data-dismiss="modal"><i class="ri-close-line"></i></button>
                        </div>

                        <!-- Modal body -->
                        <div class="modal-body">
                            <div class="table-responsive product-create">
                                <table class="table table-custom mb-0">
                                    <thead>
                                    <tr>
                                        <th style="width: 160px">Order #</th>
                                        <th>Planned Delivery Date</th>
                                        <th>Vendor</th>
                                        <th>Amount</th>
                                        <th>Added By</th>
                                        <th>Created</th>
                                        <th>Updated</th>
                                        <th>Status</th>
                                        <th style="width: 100px">Action </th>
                                    </tr>
                                    </thead>
                                    <template v-if="orderData.purchases != null">
                                        <template v-for="(item, index) in orderData.purchases.data">
                                            <tr :id="item.id">
                                                <td>
                                                    <router-link :to="{ name: 'purchaseOrderShow', params: { id: item.id }}" class="edit-btn" target="_blank">#{{ item.po_number }}</router-link>
                                                </td>
                                                <td>{{ item.eta }}</td>
                                                <td>
                                                    <router-link target="_blank" :to="{ name: 'vendorDetails', params: { id: item.vendor_id }}" class="edit-btn">
                                                        {{ item.vendor ? item.vendor.company_name : '' }}
                                                    </router-link>
                                                </td>
                                                <td>${{ item.amount }}</td>
                                                <td>{{ item.added_by ? item.added_by.name : '' }}</td>
                                                <td>{{ item.created_at_date }}</td>
                                                <td>{{ item.updated_at_date }}</td>
                                                <td><span :class="formatStatusClass(item)">{{ item.purchase_order_status ? item.purchase_order_status.name : "" }}</span></td>

                                                <td>
                                                    <button type="button" v-on:click="addProductToPO(item)" class="btn btn-small btn-primary white-space">Add products to this PO</button>
                                                    <button type="button" class="btn btn-small btn-danger skippo-btn white-space" data-dismiss="modal">Skip and continue new PO creation</button>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>

                                </table>

                                <div class="btnrow text-left" v-if="orderData.purchases != null && orderData.purchases.data.length">
                                    <template>
                                        <div class="overflow-auto">
                                            <b-pagination
                                                v-model="current_page"
                                                :total-rows="total"
                                                :per-page="per_page"
                                            ></b-pagination>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>


                        </div>
                    </div>
                </div>

            </div>
        <VendorAddModal @vendorDataSaved="vendorDataSaved"></VendorAddModal>
    </div>
</template>

<script>

import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import Vendors from "../../components/Vendors";
import Vue from "vue";
import VendorAddModal from "../../components/VendorAddModal";

export default {
    name: "PurchaseSelectVendor",
    components: {
        Vendors,
        VendorAddModal
    },
    created() {
        if (this.purchaseOrderState) {
            this.newOrder = this.purchaseOrderState.newOrder;
        }
    },
    beforeRouteLeave (to, from , next) {
        if(to.name == 'purchaseSelectProducts' || to.name == 'purchaseProvideOtherInfo' || this.saveDone == true) {
            next();
        } else {
            const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
            if (answer) {
                next();
            } else {
                next(false);
            }
        }
    },
    data() {
        return {
            bus: new Vue(),
            newOrder: {
                vendor: null,
                order_id: null,
                vendor_id: null,
                vendor_company_name: null,
                is_draft: 0,
                po_number: null,
                order_date: null,
                vendor_terms: null,
                vendor_po: null,
                vendor_fob: null,
                eta: null,
                delivery_date: null,
                notes: null,
                vendor_notes: null,
                po_status_id: 1,
                products: [],
                selectedProducts: [],
                quote_num: null
            },
            search_filter: null,
            totalQuotations: 0,
            orderData: {
                purchases: {
                    data: []
                },
                config: null,
            },
            current_page:1,
            per_page:10,
            total:0,
            saveDone: false,
            isMounted: false
        }
    },
    mounted() {
        if(this.newOrder && this.newOrder.vendor_id) {
            this.search_filter = this.newOrder.vendor_company_name;
        }
        this.isMounted = true;
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setNewPurchaseOrder',
            'setLoading'
        ]),
        goBack() {
            this.$router.push({name: 'purchaseSelectProducts'});
        },
        vendorDataSaved(vendor) {
            if (vendor) {
                if(vendor.company_name){
                    this.search_filter = vendor.company_name;
                }

                this.newOrder.vendor_id = vendor.id;
                this.newOrder.vendor = vendor;
                this.newOrder.vendor_terms = vendor.vendor_terms;
                this.bus.$emit('getVendors');
            }
            $('#vendorAddModal').modal('hide');
        },
        selectVendor(c) {
            this.newOrder.vendor_id = null;
            if (c) {
                this.newOrder.vendor_id = c.id;
                this.newOrder.vendor = c;
                this.newOrder.vendor_terms = c.vendor_terms;

                this.getPurchaseOrders(c.id);
            }

            this.setNewPurchaseOrder(this.newOrder);
        },
        search() {
            this.bus.$emit('getVendors')
        },
        addProductToPO(po){
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('po.products.store', {id: po.id}), {
                products: this.newOrder.products
            },{

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                        self.setCommonErrors(data.errors);
                    } else {
                        $('#poModal').modal('hide');
                        self.setSuccessMessage('Products added successfully!');
                        self.saveDone = true;
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                            self.$router.push({ name: 'purchaseOrderShow', params: { id: po.id } });
                        }, 10);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getPurchaseOrders(vendor_id) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('vendors.po.index', {id: vendor_id, order_id: this.newOrder.order_id}), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.orderData = data.data;
                        this.current_page = data.data.purchases.current_page;
                        this.per_page = data.data.purchases.per_page;
                        this.total = data.data.purchases.total;

                        if(this.total > 0) {
                            $('#poModal').modal('show');
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        formatStatusClass(item) {
            if(item.purchase_order_status) {
                return item.purchase_order_status.name.replace(" ", "-").replace("/", "-").toLowerCase();
            }
            return "";
        }
    },
    watch: {
        search_filter: {
            handler: function (value) {
                if (value != null && value.length > 1) {
                    this.search();
                }
            }
        }
    },
    computed: {
        ...mapState([
            'userState',
            'purchaseOrderState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
            'getPurchaseOrderState'
        ])
    }
}
</script>

<style scoped>

</style>
